// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__xzj9G","input":"Input_input__t2itI","password":"Input_password__mzpE-","switch":"Input_switch__bwsr2"};